import { M2faComponentBase } from "./M2faComponentBase";

export class SMS2FAComponent extends M2faComponentBase {
  text = "Enter the verification code sent to you via SMS:";
}
